import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import axiosInstance from "../../components/content/axiosConfig";
import Preloader from "../../components/custom/preLoader";
import showErrorToast from "../../components/toast/toast";
import { openScopedAccount, setScopedAccount } from "../../utils/accountContext";

const CompanyStaff = () => {
  const { fisherId } = useParams();
  const history = useHistory();
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [accountName, setAccountName] = useState("");
  const [accountEmail, setAccountEmail] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const [staffRes, accountRes] = await Promise.all([
          axiosInstance.get(`api/User/GetAllStaff/${fisherId}`, {
            params: { page: 1, limit: 100 },
          }),
          axiosInstance.get(`api/company/accounts/${fisherId}`),
        ]);
        setAccountName(accountRes.data?.FullName || "");
        setAccountEmail(accountRes.data?.Email || "");
        const rows = Array.isArray(staffRes.data?.data)
          ? staffRes.data.data
          : Array.isArray(staffRes.data)
            ? staffRes.data
            : [];
        setStaff(rows);
      } catch (error) {
        showErrorToast(error.response?.data?.message || "Failed to load staff");
      } finally {
        setLoading(false);
      }
    })();
  }, [fisherId]);

  const openAccount = () => {
    openScopedAccount(
      {
        id: fisherId,
        name: accountName,
        email: accountEmail,
      },
      { history }
    );
  };

  const goAddStaff = () => {
    setScopedAccount({
      id: fisherId,
      name: accountName,
      email: accountEmail,
    });
    history.push("/createStaff");
  };

  if (loading) return <Preloader />;

  return (
    <div className="container-fluid py-3">
      <Link to={`/company/accounts/${fisherId}`} className="text-muted">
        ← Back to account
      </Link>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-2 mb-3">
        <h1 className="page-header mb-0">Staff — {accountName}</h1>
        <div className="d-flex flex-wrap gap-2">
          <button type="button" className="btn btn-primary btn-sm" onClick={goAddStaff}>
            Add staff
          </button>
          <button type="button" className="btn btn-outline-primary btn-sm" onClick={openAccount}>
            Open account (sampling)
          </button>
        </div>
      </div>
      <div className="card">
        <div className="table-responsive">
          <table className="table mb-0 align-middle">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {staff.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-center text-muted py-4">
                    No staff found
                  </td>
                </tr>
              ) : (
                staff.map((row) => (
                  <tr key={row.id}>
                    <td>{row.FullName}</td>
                    <td>{row.Email}</td>
                    <td>{row.Status ? "Active" : "Inactive"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CompanyStaff;
